import Tooltip from '@mui/material/Tooltip'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  tooltip: {
    marginTop: -theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
}))

export const TableCellTooltip = props => {
  const classes = useStyles()
  const requiredTitle = props.title || ''

  return (
    <Tooltip
      placement="bottom-start"
      classes={classes}
      disableHoverListener={!props.title}
      {...props}
      title={requiredTitle}
    />
  )
}
